import axios from 'axios';

export const updateSlag = async (slagId: string, slagPage: string) => {
    const response = await axios.put(
        '/api/user/slag',
        { slagId, slagPage },
        { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
};
